// Mock data for Aigentrix clone (frontend-only).
// NOTE: All data here is MOCKED and persisted only in browser memory/localStorage.

export const user = {
  name: "Kris",
  email: "juttkri@gmail.com",
  phone: "+44 7739 692454",
  phoneRaw: "447739692454",
  role: "ADMIN",
  organisation: "Kris Organisation",
  language: "English",
  status: "Active",
  avatar: "https://i.pravatar.cc/120?img=12",
  initials: "KR",
  mfaEnabled: false,
};

export const dashboard = {
  invoiceDocs: { used: 0, total: 100 },
  aiCredits: { used: 0, total: 500 },
  onboarding: {
    completed: 0,
    total: 5,
    steps: [
      { id: "company", label: "Add a company", done: false, active: true },
      { id: "trn", label: "Register TRN", done: false },
      { id: "peppol", label: "Set up PEPPOL", done: false },
      { id: "invoice", label: "Send first invoice", done: false },
      { id: "team", label: "Invite a teammate", done: false },
    ],
  },
  stats: [
    { label: "Invoices this month", value: "0", sub: "This month" },
    { label: "Needs attention", value: "0", sub: "This month" },
    { label: "Pass rate", value: "0%", sub: "This month" },
    { label: "Inbound received", value: "0", sub: "This month" },
  ],
  shortcuts: [
    { id: "parse", icon: "ScanText", title: "Parse documents", desc: "Extract structured data with AI" },
    { id: "extract", icon: "FileSearch", title: "Run extraction", desc: "Batch process uploaded files" },
    { id: "inbox", icon: "Mail", title: "Review inbox", desc: "Process incoming document emails" },
    { id: "integrations", icon: "Plug", title: "Connect integrations", desc: "Link ERP, VAT, and workflow tools" },
  ],
};

export const settingsCards = [
  { id: "subscription", icon: "Wallet", title: "Manage subscription", desc: "Manage plan, billing, and subscription access." },
  { id: "company", icon: "Building2", title: "Company Settings", desc: "Configure company setup and master settings." },
  { id: "party", icon: "FileText", title: "Party Companies", desc: "Manage party and company related records." },
  { id: "erp", icon: "Network", title: "ERP/CRM Connections", desc: "Set up ERP and CRM system connections." },
  { id: "member", icon: "User", title: "Member", desc: "Manage users, roles, and workspace members." },
  { id: "apikey", icon: "KeyRound", title: "API Key", desc: "Create and manage secure API access keys." },
  { id: "integration", icon: "Plug", title: "Integration & Setup", desc: "Connect third-party tools and integrations." },
  { id: "intelligence", icon: "Database", title: "Intelligence hub", desc: "Configure intelligence hub and data pipelines." },
];

export const subscriptionPlans = {
  current: [
    {
      name: "E-Invoice", fee: "0", planLabel: "Free", expires: "Jul 24, 2027",
      creditUsed: 0, creditTotal: 100, status: "ACTIVE",
      note: "As an officially Approved UAE E-Invoicing Service Provider, we deliver end-to-end compliance with the Federal Tax Authority's mandates.",
    },
    {
      name: "Ai agent", fee: "0", planLabel: "FREE", expires: "Jul 24, 2026",
      creditUsed: 0, creditTotal: 500, status: "ACTIVE",
      note: "Ai agent is your AI-powered business intelligence engine. Extract, automate, and integrate data from any document, email, or invoice across every market you operate in.",
    },
  ],
  eInvoicePlans: [
    { name: "FREE", price: "0", docs: "100 docs", active: true },
    { name: "STARTUP", price: "400", docs: "500 docs" },
    { name: "ESSENTIAL", price: "600", docs: "1,200 docs" },
    { name: "BUSINESS", price: "1,200", docs: "3,000 docs" },
    { name: "BUSINESS PRO", price: "12,000", docs: "3,000 docs", popular: true },
  ],
  aiAgentPlans: [
    { name: "FREE", price: "0", docs: "500 credits", active: true },
    { name: "GROWTH", price: "900", docs: "5,000 credits" },
    { name: "SCALE", price: "2,400", docs: "20,000 credits" },
    { name: "ENTERPRISE", price: "6,000", docs: "75,000 credits", popular: true },
  ],
  features: [
    "UAE FTA compliant e-Invoicing",
    "API access (free)",
    "PEPPOL network delivery",
    "AI document extraction",
    "Email & priority support",
  ],
};

export const erpConnections = [
  { id: "erp", name: "ERP", logo: "https://app.aigentrix.ai/favicon.ico", desc: "Transform your business with AI-powered document processing, comprehensive ERP, e-invoicing, and digital solutions. Streamline operations, ensure compliance, and drive growth with intelligent automation." },
  { id: "zoho", name: "Zoho Books", letter: "Z", color: "#e53935", desc: "Zoho Books is a comprehensive, cloud-based accounting software designed for small to medium-sized businesses to manage finances, automate workflows, and handle daily transactions." },
  { id: "qb", name: "QuickBooks", letter: "qb", color: "#2ca01c", desc: "QuickBooks is a comprehensive accounting software package developed by Intuit for small to medium-sized businesses, designed to manage income, expenses, invoicing, and financial reporting." },
  { id: "tally", name: "Tally", letter: "T", color: "#1565c0", desc: "TallyPrime is a comprehensive, user-friendly business management software used for accounting, inventory management, taxation (GST), and payroll." },
  { id: "odoo", name: "Odoo", letter: "o", color: "#714b67", desc: "Odoo is a comprehensive, open-source, all-in-one business management software suite covering CRM, e-commerce, accounting, manufacturing, and inventory." },
];

export const integrationProviders = [
  { id: "google", name: "Google", color: "#ea4335", letter: "G" },
  { id: "microsoft", name: "Microsoft", color: "#0078d4", letter: "M" },
  { id: "imap", name: "IMAP", color: "#f59e0b", letter: "@" },
  { id: "autoforward", name: "Auto Forward", color: "#16a34a", letter: "AF" },
  { id: "whatsapp", name: "Whatsapp Forward", color: "#25d366", letter: "W" },
  { id: "awss3", name: "AWS S3 Bucket", color: "#ff9900", letter: "S3" },
  { id: "oci", name: "OCI Bucket", color: "#c74634", letter: "OCI" },
  { id: "onedrive", name: "OneDrive", color: "#0078d4", letter: "OD" },
  { id: "gdrive", name: "Google Drive", color: "#1da462", letter: "GD" },
];

export const companyColumns = ["Id", "Company Code", "Company Name", "Vat Registration No", "Vat/Tax Number", "Building Number", "Street Name", "City", "Country", "Currency", "Postal Code", "Parent Company", "Status", "Created At"];
export const memberColumns = ["Name", "Email", "Phone", "Status", "Multi-Factor Authentication (Mfa)", "Created At"];
export const apiKeyColumns = ["Name", "Api Key", "Created By", "Created At"];
export const intelligenceColumns = ["Id", "Name", "Row Count", "Created At"];
export const partyColumns = ["Id", "Party Code", "Party Name", "Vat/Tax Number", "Email", "Phone", "Country", "Type", "Status", "Created At"];

export const parseStatuses = [
  { id: "pending", label: "Pending", count: 0 },
  { id: "completed", label: "Completed", count: 0 },
  { id: "failed", label: "Failed", count: 0 },
  { id: "cancelled", label: "Cancelled", count: 0 },
  { id: "intransit", label: "In Transit", count: 0 },
];
